<script>
export default {
  name: 'FYUserMenu',
  methods: {
    goto(formType) {
      if (formType == 'finalize') {
        this.$router.push({ name: 'FYUserFinalize' })
      } else {
        this.$router.push({
          name: 'FormSearch',
          params: { formType }
        })
      }
    },
    regenerate() {
      this.$bvModal
        .msgBoxConfirm(
          'Are you sure you want to refresh the fiscal year user metrics? Note: this process can take several minutes.',
          {
            title: 'Please Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            this.graphql(/* GraphQL */ `
              mutation {
                refreshFyUserMetrics(input: {}) {
                  clientMutationId
                }
              }
            `)
          }
        })
    }
  }
}
</script>

<template>
  <div class="p-4">
    <b-card-group deck class="w-100">
      <b-card
        title="Affiliation Types"
        class="m-2"
        @click="goto('affiliationTypes')"
      >
        <b-card-text>
          Manage type of business for affilations for DOE user metrics
        </b-card-text>
      </b-card>
      <b-card
        title="Approved / Excluded Projects"
        class="m-2"
        @click="goto('fyUserMetricsDecisions')"
      >
        <b-card-text>
          Manage user projects that have been marked as Approved or Excluded
        </b-card-text>
      </b-card>
      <b-card
        title="Finalize Fiscal Year Metrics"
        class="m-2"
        @click="goto('finalize')"
      >
        <b-card-text>
          Copy the final fiscal year metrics and export the spreadsheet to turn
          in to DOE
        </b-card-text>
      </b-card>
    </b-card-group>
    <b-card-group deck class="w-100">
      <b-card
        title="Final User Metrics"
        class="m-2"
        @click="goto('fyFinalMetrics')"
      >
        <b-card-text>
          Final approved version of fiscal year user metrics as turned in to DOE
        </b-card-text>
      </b-card>
      <b-card
        title="Ignored Project Titles"
        class="m-2"
        @click="goto('ignoredProjectTitles')"
      >
        <b-card-text>
          Manage project titles that are ignored when generating the FY User
          Metrics
        </b-card-text>
      </b-card>
      <b-card
        title="Manual User Projects"
        class="m-2"
        @click="goto('fyUserMetricsManual')"
      >
        <b-card-text>
          Manage user projects that have been manually entered
        </b-card-text>
      </b-card>
    </b-card-group>
    <b-card-group deck class="w-100">
      <b-card title="Regenerate" class="m-2" @click="regenerate">
        <b-card-text>
          Regenerate the Fiscal Year User Metrics
        </b-card-text>
      </b-card>
    </b-card-group>
  </div>
</template>
